import GenericExporter from './generic';
import fountain from '../vendor/fountain';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "../vendor/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
	courier: {
     normal: 'cps.ttf',
     bold: 'cps-bold.ttf',
     italics: 'cps-italic.ttf',
     bolditalics: 'cps-bi.ttf'
   },
}
class FountainToPDFExporter extends GenericExporter {
	getName() {
		return 'Fountain PDF';
	}

	getDescription() {
		return `Converts a fountain script into a formatted PDF
		suitable for screen reading.`;
	}

	getFileType() {
		return '.pdf';
	}

	getMimeType() {
		return 'application/pdf';
	}

	export(text) {
		return new Promise((resolve, reject) => {
			// margins are in points
			// screenplay settings are in http://storysense.com/format/margins.htm
			let inch = 72;
			let line_height = 12;
			let doc = {
				content: [],
				pageSize: 'LETTER',
				pageMargins: [ inch*1.5, inch, inch, inch ],
				footer: function(currentPage, pageCount) {
			        return [
			            {text: currentPage.toString() + ' / ' + pageCount, style: 'footer'}
			        ];
			    },
				defaultStyle: {
				    font: 'courier',
				    fontSize: line_height
				},
				styles: {
					footer: {
						alignment: 'center',
						margin: [0, 18, 0, 0]
					},
					character: {
						margin: [inch*2.7, 0, 0, 0]
					},
					dialogue: {
						margin: [inch*1.4, 0, inch*1.3, line_height],
					},
					scene_heading: {
						bold: true,
						margin: [0, 0, 0, line_height]
					},
					action: {
						margin: [0, 0, 0, line_height]
					},
					parenthetical: {
						margin: [inch*2.1, 0, inch*1.9, 0],
					},
					transition: {
						margin: [0, 0, 0, line_height],
						italics: true
					}
				},
				pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
				    return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
				}
			};

			let content = doc.content;
			fountain.parse(text, true, function(result) {
				if (result) {
					// create pdf from the tokens
					for (let i = 0; i < result.tokens.length; i++) {
						let token = result.tokens[i];
						if (token.text) {
							content.push({
								text: token.text.replace(/<(?:.|\n)*?>/gm, ''),
								style: token.type
							});
						}
					}

					pdfMake.createPdf(doc).getBlob((blob) => {
						resolve(blob);
					});

				} 
				else {
					reject(new Error('there is no result'));
				}
			});
		});
	}
}

export default FountainToPDFExporter;


// WEBPACK FOOTER //
// ./src/exporters/fountain-to-pdf.js